export default __webpack_public_path__ + "static/media/home-osehero-people.5d28efa2.png";